import React from "react";
import { maskCpfCnpj } from "../../utils/Masks/Masks";
import Select from "../../components/Inputs/Select/Select";

const FormIndustrial = (props) => {
  const {
    department,
    departmentOptions,
    onDepartmentChange,
    onPhoneNumberChange,
    isPhoneNumberValid,
    haveSubmited,
    phoneNumber,
    disabledInput,
    name,
    isNameValid,
    onNameChange,
    cpf,
    isCpfValid,
    onCpfChange,
    isEmailValid,
    email,
    onEmailChange,
  } = props;

  return (
    <>
      <input
        type="text"
        value={name}
        onChange={onNameChange}
        disabled={disabledInput}
        placeholder="Nome"
        className={`block ${!isNameValid && haveSubmited ? "error" : ""}`}
      />
      <input
        type="text"
        value={maskCpfCnpj(cpf || "")}
        onChange={onCpfChange}
        placeholder="Cpf"
        disabled={disabledInput}
        className={`block ${!isCpfValid && haveSubmited ? "error" : ""}`}
      />
      <Select
        type="text"
        className="block"
        value={department}
        disabled={disabledInput}
        onChange={onDepartmentChange}
        options={departmentOptions || []}
        style={{ color: "var(--light-blue)" }}
      />
      <input
        type="text"
        className={`block ${
          !isPhoneNumberValid && haveSubmited ? "error" : ""
        }`}
        placeholder="Telefone"
        value={phoneNumber}
        onChange={onPhoneNumberChange}
        disabled={disabledInput}
      />
      <input
        type="text"
        className={`block ${!isEmailValid && haveSubmited ? "error" : ""}`}
        placeholder="Email"
        value={email}
        onChange={(e) => {
          const v = e.target.value;
          const sanitized = v
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[^a-zA-Z0-9@._-]/g, "");

          e.target.value = sanitized;
          onEmailChange(e);
        }}
        disabled={disabledInput}
      />
    </>
  );
};

export default FormIndustrial;
